<template>
    <van-popup class="dialog_box" v-model="showDialog" round :close-on-click-overlay="false" @click-overlay="$emit('clickOverlay')">
        <slot></slot>
        <div class="dialog_btn_box">
            <van-button class="dialog_btn btn_cacel" round @click="$emit('dialogCancel')">{{ cancelBtn }}</van-button>
            <van-button class="dialog_btn btn_confirm" round @click="$emit('dialogConfirm')">{{ confirmBtn }}</van-button>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        showDialog: {
            type: Boolean,
            require: true,
        },
        cancelBtn: {
            type: String,
            default: "取消"
        },
        confirmBtn: {
            type: String,
            default: "确认"
        }
    },
}

</script>

<style lang='scss' scoped>
.dialog_box {
    width: 315px;
    padding: 25px 20px;
    text-align: center;

    .dialog_btn_box {
        display: flex;
        justify-content: space-between;
        margin-top: 27px;

        .dialog_btn {
            width: 130px;
            height: 40px;
            border-radius: 20px;
        }

        .btn_cacel {
            font-size: 14px;
            color: #333333;
        }

        .btn_confirm {
            background-color: #4A79F1;
            font-size: 14px;
            color: #FFFFFF;
        }
    }
}
</style>